"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentStatus = void 0;
var FulfillmentStatus;
(function (FulfillmentStatus) {
    FulfillmentStatus[FulfillmentStatus["New"] = 1] = "New";
    FulfillmentStatus[FulfillmentStatus["Shipped"] = 2] = "Shipped";
    FulfillmentStatus[FulfillmentStatus["Delivered"] = 4] = "Delivered";
})(FulfillmentStatus = exports.FulfillmentStatus || (exports.FulfillmentStatus = {}));
//# sourceMappingURL=FulfillmentStatus.js.map